import getXyManagePathPrefix from '@/utils/getXyManagePathPrefix';
import { createAiProjectInfoExclude, hasCompleteArtifactCos, shouldUseSlimAiProjectInfo } from '@/utils/aiProjectInfo';
import wujiFetch from '@/utils/wujiFetch';
class AiProjectLoader {
    async getProjectInfo(projectId, env, branchId, options = {}) {
        if (options.forceFullArtifact || !shouldUseSlimAiProjectInfo({ env, branchId })) {
            return await this.requestProjectInfo(projectId, env, branchId);
        }
        const slimAiProjectInfo = await this.requestProjectInfo(projectId, env, branchId, true);
        if (hasCompleteArtifactCos(slimAiProjectInfo)) {
            return slimAiProjectInfo;
        }
        return await this.requestProjectInfo(projectId, env, branchId);
    }
    createProjectInfoUrl(projectId, env, branchId, excludeArtifact = false) {
        const params = new URLSearchParams({ projectId });
        params.set('exclude', createAiProjectInfoExclude({ excludeArtifact }));
        return `${getXyManagePathPrefix({ envId: env, branchId })}/ai-project/info?${params.toString()}`;
    }
    async requestProjectInfo(projectId, env, branchId, excludeArtifact = false) {
        const url = this.createProjectInfoUrl(projectId, env, branchId, excludeArtifact);
        return wujiFetch(url);
    }
}
export default new AiProjectLoader();
